import {ChangeDetectionStrategy, Component, DestroyRef, inject,} from '@angular/core';
import { ButtonComponent } from '../../../assets/shared/button/button.component';
import { AuthService } from '../../core/services/auth/auth.service';
import { Location } from '@angular/common';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'confirm',
  imports: [ButtonComponent],
  templateUrl: './confirm.component.html',
  styleUrl: './confirm.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmComponent {
  private auth = inject(AuthService);
  private location = inject(Location);
  private destroy = inject(DestroyRef)

  public inconsistent = this.auth.getConsentStatus()?.['confirmConsent'];

  public confirmConsent() {
    let scopeArray = this.auth
      .getConsentStatus()
      ?.['confirmConsent'].map((x: any) => x.code);

    this.auth.confirmForScopes(scopeArray)
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe({
      next: (data) => {
        this.auth.getConsentStatus();
        this.auth.setConsentStatus({ confirmConsent: null });
        this.location.back();
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  public cancel() {
    this.auth.authorize();
    this.location.back();
  }
}
